"use client";
import { MessageCircle } from 'lucide-react';
import whatsapp from '../../assets/whatsapp.png';

const WhatsApp = () => {
  return (
    <a
      href="https://wa.me/33763519524"
      target="_blank"
      rel="noopener noreferrer"
      className="
        fixed bottom-20 right-5 md:bottom-8 md:right-8
        z-50
        flex items-center gap-3
        p-2 md:p-2.5
        transition-all
        group
      "
    >
      <div >
        {/* <MessageCircle className="w-5 h-5 text-green-600" /> */}
        <img src={whatsapp} alt="WhatsApp" className="w-10 h-10 md:w-12 md:h-12" />
      </div>
    </a>
  );
}

export default WhatsApp;